import { render, staticRenderFns } from "./CorporatePolicies.vue?vue&type=template&id=60d97b50&"
import script from "./CorporatePolicies.vue?vue&type=script&lang=js&"
export * from "./CorporatePolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports